export default __webpack_public_path__ + "static/media/mic.e65b1b66.png";